import React from 'react';
interface TabsProps {
  tabs: {
    id: string;
    label: string;
  }[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
export const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange
}) => {
  return <div className="relative flex overflow-x-auto scrollbar-hide gap-1 p-1 bg-white/70 dark:bg-gray-900/40 rounded-lg backdrop-blur-sm border border-gray-200/50 dark:border-purple-500/20 shadow-[0_4px_12px_rgba(168,85,247,0.1)]" data-id="element-23687">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-5 pointer-events-none" data-id="element-23688"></div>
      {tabs.map(tab => <button key={tab.id} className={`relative px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap group ${activeTab === tab.id ? 'text-gray-900 dark:text-white' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-300'}`} onClick={() => onTabChange(tab.id)} data-id="element-23689">
          {/* Tab background */}
          <div className={`absolute inset-0 rounded-lg transition-all duration-300 ${activeTab === tab.id ? 'bg-gradient-to-b from-gray-100/90 to-white/90 dark:from-gray-800/90 dark:to-gray-900/90 shadow-[0_2px_10px_rgba(168,85,247,0.15)]' : 'bg-transparent group-hover:bg-gray-100/80 dark:group-hover:bg-gray-800/50'}`} data-id="element-23690"></div>
          {/* Background pattern for active tab */}
          {activeTab === tab.id && <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-10 rounded-lg pointer-events-none" data-id="element-23691"></div>}
          {/* Glowing underline for active tab */}
          {activeTab === tab.id && <div className="absolute bottom-0 left-2 right-2 h-[2px] bg-gradient-to-r from-purple-500 to-pink-500 rounded-full shadow-[0_0_8px_rgba(168,85,247,0.5)]" data-id="element-23692"></div>}
          {/* Tab label */}
          <span className="relative z-10" data-id="element-23693">{tab.label}</span>
          {/* Subtle glow on hover */}
          <div className={`absolute inset-0 rounded-lg pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${activeTab !== tab.id ? 'bg-gradient-to-b from-purple-100/5 to-pink-100/5 dark:from-purple-500/5 dark:to-pink-500/5' : ''}`} data-id="element-23694"></div>
        </button>)}
    </div>;
};